import React from 'react';
import useStyles from './styles';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
export default function DefaultSubscriptionUnit(_ref) {
  let amount = _ref.amount,
    count = _ref.count,
    name = _ref.name;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.sectionWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.section
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, name), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "$", Number(amount).toFixed(2), "/each")), /*#__PURE__*/React.createElement("div", {
    className: classes.rationBillingSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.ratioBilling
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('Current usage')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, count, " / $", Number(count * amount).toFixed(2)))));
}